export const AUTH_TOKEN = 'auth.token'
export const MAKE_ID = 'auth.make'
